import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { CustomEntity } from "../../entities/customGame";
import { getV3GameEntity, patchV3GameEntity, postCustom } from "./thunks";

interface V3GameState {
  loading: boolean,
  saveLoading: boolean,
  entity?: CustomEntity,
}

const initialState: V3GameState = {
  loading: false,
  saveLoading: false,
}

export const v3GamesSlice = createSlice({
  name: 'v3_games',
  initialState,
  reducers: {
    clearEntityState: (state: Draft<V3GameState>) => {
      state.entity = undefined;
    }
  },
  extraReducers: (builder) => {
    // postCustom
    builder.addCase(postCustom.pending, (state) => {
      state.saveLoading = true
    })
    builder.addCase(postCustom.fulfilled, (state, action: PayloadAction<CustomEntity>) => {
      state.entity = action.payload;
      state.saveLoading = false
    })
    builder.addCase(postCustom.rejected, (state) => {
      state.saveLoading = false
    })
    // getV3GameEntity
    builder.addCase(getV3GameEntity.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getV3GameEntity.fulfilled, (state, action: PayloadAction<CustomEntity>) => {
      state.entity = action.payload;
      state.loading = false
    })
    builder.addCase(getV3GameEntity.rejected, (state) => {
      state.loading = false
    })
    // patchV3GameEntity
    builder.addCase(patchV3GameEntity.pending, (state) => {
      state.saveLoading = true
    })
    builder.addCase(patchV3GameEntity.fulfilled, (state, action: PayloadAction<CustomEntity>) => {
      state.entity = action.payload;
      state.saveLoading = false
    })
    builder.addCase(patchV3GameEntity.rejected, (state) => {
      state.saveLoading = false
    })
  },
})

export const { clearEntityState } = v3GamesSlice.actions;

export default v3GamesSlice.reducer;